(function() {
	'use strict';
	var $ = avm.require('cash'),
		$open = $('.js-open'),
		$close = $('.js-close');

	$open.on('click', function() {
		var $target = $(this).parents('section').next('section');

		$target.addClass('show');
		$(this).addClass('hidden');
	});

	$close.on('click', function() {
		var $target = $(this).parents('section'),
			$openButton = $target.prev('section').find('.js-open');

		$openButton.removeClass('hidden');
		$target.removeClass('show');
	});
})();
